<template>
  <div class="app-container">
    <CrudTable entity="Translation" :columns="columns" :allow-create="false" :allow-delete="false" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [{ field: 'code', label: 'translation.code' }, 'description']
    };
  }
};
</script>

<style scoped></style>
